import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Qué recibiré al comprar este producto?',
    a: 'Acceso inmediato al libro digital y todos los bonos.'
  }, {
    q: '¿Puedo leerlo en celular, tablet o computadora?',
    a: 'Sí, funciona en todos los dispositivos.'
  }, {
    q: '¿Cuándo lo recibo?',
    a: 'Inmediatamente después de completar la compra.'
  }, {
    q: '¿Qué pasa si tengo problemas para descargar?',
    a: 'Nuestro soporte te ayudará.'
  }, {
    q: '¿Necesito experiencia?',
    a: 'No. Todo está explicado paso a paso.'
  }, {
    q: '¿Qué métodos de pago aceptan?',
    a: 'Tarjetas de crédito, débito y plataformas de pago seguras.'
  }];
  return <section className="py-12 px-4 bg-cream-100" data-id="element-47">
      <div className="max-w-3xl mx-auto" data-id="element-48">
        <h2 className="text-3xl md:text-4xl font-bold text-espresso-900 mb-8 text-center" data-id="element-49">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-3" data-id="element-50">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} data-id="element-51" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-white rounded-xl border border-espresso-900/10 overflow-hidden" data-id="element-52">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-5 py-4 text-left flex justify-between items-center focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-500" data-id="element-53">
        <span className="font-bold text-espresso-900 text-base pr-4" data-id="element-54">
          {question}
        </span>
        <ChevronDown className={`w-5 h-5 text-espresso-700 transition-transform duration-300 flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-55" />
      </button>
      <AnimatePresence data-id="element-56">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-57">
            <div className="px-5 pb-4 text-espresso-700 text-sm" data-id="element-58">{answer}</div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}